import { render, staticRenderFns } from "./InsightsOverlay.vue?vue&type=template&id=490a3121&"
import script from "./InsightsOverlay.js?vue&type=script&lang=js&"
export * from "./InsightsOverlay.js?vue&type=script&lang=js&"
import style0 from "./InsightsOverlay.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports